// extracted by mini-css-extract-plugin
module.exports = {"container":"global_container__fW6iW","head_container":"global_head_container__2MmoP"};